import React from 'react';
import { formatLocalizedDateTime } from '@saviynt/common';
import {
  ButtonIcon,
  Chip,
  Icon,
  Tooltip,
  Typography,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { msgs } from '../../../utilities/messages';
import CountdownTimer from '../../CountdownTimer/CountdownTimer';

/**
 * Trailing content of an access-key ListRow: the status chip, the countdown/schedule
 * chip, and the delete action.
 */
const KeyRowTrailing = React.memo(
  ({ keyItem, onDeleteClick, onTimerExpired, localize }) => {
    const isActive = new Date(keyItem.startTime) <= new Date();

    return (
      <div className='ListRow-sectionRight'>
        <div className='ListRow-status'>
          <Chip
            kind='subtleFilled'
            color={isActive ? 'success' : 'info'}
            label={
              isActive
                ? localize(msgs.pam.apiKeys.active)
                : localize(msgs.pam.apiKeys.scheduled)
            }
            size='medium'
          />
        </div>
        <div className='ListRow-icon'>
          <Chip
            kind='subtleFilled'
            color='brandSecondary'
            classNames={{
              contentContainerClassName: 'AccessKeysSection-countdownChip',
            }}
            label={
              <Typography kind='body2'>
                {isActive ? (
                  <CountdownTimer
                    targetDate={keyItem.expireTime}
                    leftText={localize(msgs.pam.sidePanel.left)}
                    onTimerExpired={onTimerExpired}
                  />
                ) : (
                  formatLocalizedDateTime(keyItem.startTime, false, false)
                )}
              </Typography>
            }
            leftIcon={
              <Icon kind={isActive ? 'Time' : 'Calendar'} size='medium' />
            }
          />
        </div>
        <div className='ListRow-verticalIcon AccessKeysSection-deleteButton'>
          <Tooltip
            text={localize(msgs.pam.apiKeys.deleteKey)}
            placement='top'
            trigger={
              <ButtonIcon
                kind='outlinedCritical'
                size='large'
                ariaLabel={localize(msgs.pam.apiKeys.deleteKeySlot, {
                  slot: keyItem.slot,
                })}
                onClick={() => onDeleteClick(keyItem)}
                icon={<Icon kind='Delete' color='critical-500' />}
              />
            }
          />
        </div>
      </div>
    );
  }
);

KeyRowTrailing.propTypes = {
  keyItem: PropTypes.shape({
    slot: PropTypes.number.isRequired,
    startTime: PropTypes.string.isRequired,
    expireTime: PropTypes.string.isRequired,
  }).isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onTimerExpired: PropTypes.func.isRequired,
  localize: PropTypes.func.isRequired,
};

export default KeyRowTrailing;
